import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/shipLineTransPay'


export function getStowageCustomerGoods(querydata) {
  return request({
    url:`${BASE_REQUEST}/getStowageCustomerGoods`,
    data:querydata
  })
}

export function getShipLineTransPayList(querydata) {
        return request({
            url:`${BASE_REQUEST}/getShipLineTransPayList`,
            data:querydata
        })
}

export function selectShipPayAndNo1020(querydata) {
  return request({
      url:`${BASE_REQUEST}/selectShipPayAndNo1020`,
      data:querydata
  })
}

export function updateShipLineTransPay(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/updateShipLineTransPay`,
        data:obj
    })
}

export function delShipLineTransPay(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delShipLineTransPay`,
        data:{id: id}
    })
}

export function saveShipLineTransPay(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/saveShipLineTransPay`,
        data:obj
    })
}

export function updateShipPay(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateShipPay`,
    data:querydata
  })
}

export function getCompanyPaymentList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getCompanyPaymentList`,
    data:querydata
  })
}

export function updateApplyStatus(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateApplyStatus`,
    data:querydata
  })
}

export function updateTicketApplyStatus(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateTicketApplyStatus`,
    data:querydata
  })
}

export function getCompanyReceiveList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getCompanyReceiveList`,
    data:querydata
  })
}

export function selectShipPay(
  id
) {
  return request({
    url:`${BASE_REQUEST}/selectShipPay`,
    data:{shipLineId: id}
  })
}
